var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1207_21395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9722 18.516C18.9329 15.8743 16.4242 13.0653 14.2821 11.6228C12.8836 10.6811 11.1166 10.6811 9.71809 11.6228C7.57594 13.0653 5.06732 15.8743 4.02802 18.516C2.89301 21.4011 5.16561 24.5045 7.99967 23.9307C9.32854 23.6616 10.7 23.0672 12.0001 23.0625C13.3003 23.0672 14.6717 23.6616 16.0006 23.9307C18.8346 24.5045 21.1072 21.4011 19.9722 18.516H19.9722Z",
    fill: "#FE994F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24677 9.40312C10.8234 9.03229 11.6861 6.63773 11.1736 4.05473C10.6611 1.47173 8.96753 -0.321589 7.39089 0.0492465C5.81425 0.420082 4.95159 2.81464 5.46407 5.39764C5.97656 7.98064 7.67013 9.77396 9.24677 9.40312Z",
    fill: "#FE994F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54563 14.5336C5.91586 13.8363 6.31242 11.6072 5.43137 9.55464C4.55032 7.50213 2.72529 6.40349 1.35505 7.10076C-0.0151819 7.79803 -0.411742 10.0272 0.46931 12.0797C1.35036 14.1322 3.17539 15.2308 4.54563 14.5336Z",
    fill: "#FE994F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.532 12.0811C24.413 10.0286 24.0164 7.79945 22.6462 7.10218C21.276 6.40491 19.4509 7.50355 18.5699 9.55606C17.6888 11.6086 18.0854 13.8377 19.4556 14.535C20.8259 15.2323 22.6509 14.1336 23.532 12.0811Z",
    fill: "#FE994F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5347 5.39645C19.0472 2.81344 18.1845 0.418886 16.6079 0.0480506C15.0312 -0.322785 13.3376 1.47053 12.8252 4.05353C12.3127 6.63653 13.1753 9.03109 14.752 9.40193C16.3286 9.77276 18.0222 7.97945 18.5347 5.39645Z",
    fill: "#FE994F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1207_21395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.25012327217f55bc4bdf644f715e3ccf.svg";
export { ForwardRef as ReactComponent };